import BaseAbility from 'umg-ember-backend/abilities/base';

export default class ShortUrlTargetAbility extends BaseAbility {
  get permissions() {
    return this.permission.for('short-url');
  }
}
